import * as ROUTES from '@/router/route-names'

export default [
  {
    path: '/:accountId/attorneys',
    name: ROUTES.ATTORNEYS,
    component: () => import('../views/attorneys/LandingPage'),
  },

  {
    path: '/o/:token/applications',
    name: ROUTES.OPEN_APPS_LANDING,
    component: () => import('../views/attorneys/OpenAppLandingPage.vue'),
  },
  {
    path: '/o/:token/applications/:frontEndFormId',
    name: ROUTES.OPEN_APPS_FORM,
    component: () => import('../views/applications/DigitalApplicationForm.vue'),
  },
]
